module.exports = __webpack_public_path__ + "img/icon-chevron-left-gray.00a6cfa9.svg";